import React from "react";

const tableHeaderColumns = ["ID", "First Name", "Last Name", "Clients", "Orders"];

const data = [
  {
    accountId: "A123",
    firstName: "John",
    lastName: "Doe",
    clients: 100,
    orders: 50,
  },
  {
    accountId: "B456",
    firstName: "Jane",
    lastName: "Smith",
    clients: 150,
    orders: 75,
  },
  {
    accountId: "C789",
    firstName: "Bob",
    lastName: "Johnson",
    clients: 200,
    orders: 100,
  },
  {
    accountId: "D012",
    firstName: "Samantha",
    lastName: "Lee",
    clients: 75,
    orders: 40,
  },
  {
    accountId: "E345",
    firstName: "David",
    lastName: "Kim",
    clients: 50,
    orders: 25,
  },
  {
    accountId: "F678",
    firstName: "Emily",
    lastName: "Chen",
    clients: 300,
    orders: 150,
  },
  {
    accountId: "G901",
    firstName: "Michael",
    lastName: "Nguyen",
    clients: 125,
    orders: 60,
  },
  {
    accountId: "H234",
    firstName: "Lauren",
    lastName: "Wu",
    clients: 175,
    orders: 90,
  },
  {
    accountId: "I567",
    firstName: "Chris",
    lastName: "Garcia",
    clients: 225,
    orders: 110,
  },
  {
    accountId: "J890",
    firstName: "Sarah",
    lastName: "Martinez",
    clients: 80,
    orders: 45,
  },
];

export default function RecruitersTablePreview() {
  return (
    <table className="w-full text-sm text-left text-gray-700 dark:text-gray-400">
      <thead className="text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        {tableHeaderColumns.map((column) => (
          <th scope="col" className="px-6 py-3">
            <button>{column}</button>
          </th>
        ))}
      </thead>
      <tbody>
        {data &&
          data.map((dataItem) => (
            <tr
              className="cursor-pointer bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={dataItem.accountId}
            >
              <td className="px-6 py-2">{dataItem.accountId}</td>
              <td className="px-6 py-2">{dataItem.firstName}</td>
              <td className="px-6 py-2">{dataItem.lastName}</td>
              <td className="px-6 py-2">{dataItem.clients}</td>
              <td className="px-6 py-2">{dataItem.orders}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
